.stack {
  display: flex;
  min-width: 0;
}

.column {
  flex-direction: column;
}

.row {
  flex-direction: row;
}

.wrap {
  flex-wrap: wrap;
}

.gap0 {
  gap: 0;
}

.gap1 {
  gap: var(--space-1);
}

.gap2 {
  gap: var(--space-2);
}

.gap3 {
  gap: var(--space-3);
}

.gap4 {
  gap: var(--space-4);
}

.gap5 {
  gap: var(--space-5);
}

.gap6 {
  gap: var(--space-6);
}

.gap8 {
  gap: var(--space-8);
}

.align-start {
  align-items: flex-start;
}

.align-center {
  align-items: center;
}

.align-end {
  align-items: flex-end;
}

.align-stretch {
  align-items: stretch;
}

.align-baseline {
  align-items: baseline;
}

.justify-start {
  justify-content: flex-start;
}

.justify-center {
  justify-content: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-between {
  justify-content: space-between;
}
